import {Component, Input, OnDestroy, OnInit} from '@angular/core';

import {UntypedFormControl} from '@angular/forms';
import {Subscription, BehaviorSubject, Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged,  filter ,  switchMap} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {Page, PageService} from '../services';

@Component({
  selector: 'p8-bdc-admin-search-pages',
  templateUrl: './search-admin-pages.component.html',
  styleUrls: ['./search-admin-pages.component.scss']
})
export class SearchPagesComponent implements OnInit, OnDestroy {
  @Input()
  goRoute = 'page';

  term = new UntypedFormControl();
  pageSearch: Observable<Page[]>;

  subSearch: Subscription;

  subject: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private pageSvc: PageService) {
    if (this.pageSvc) {
      this.pageSearch = this.term.valueChanges
        .pipe(debounceTime(400), distinctUntilChanged(),
          filter(searchTerm => searchTerm.length >= 3),
          switchMap(data => this.pageSvc.search(data, true)));
    }
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    if (this.subSearch) {
      this.subSearch.unsubscribe();
    }
  }

  displayPageFn = (page: Page): string => {
    return '';
  }

  goPage(page: Page) {
    this.router.navigate([page.id, 'edit'], {relativeTo: this.activatedRoute});
  }
}
